import {
  GET_DEMOGRAPHICS_REQUEST,
  GET_DEMOGRAPHICS_SEARCH_RESULTS_REQUEST,
} from '../constants/action-types';

export const getDemographics = () => ({
  type: GET_DEMOGRAPHICS_REQUEST,
});

export const getDemographicsSearchResults = (q, categoryId) => ({
  type: GET_DEMOGRAPHICS_SEARCH_RESULTS_REQUEST,
  q,
  categoryId,
});
